export default {
  filterOptions: [
    'Et quidem faciunt ut',
    'In quo quaerimus non numquam',
    'Probabo inquit modo',
    'Sed ut et voluptates repudiandae',
    'Si sine causa quae fuerit',
    'Certe inquam pertinax non',
    'Epicurus in sanguinem',
    'The quick brown',
    'fox jumps over',
    'the lazy dog.',
  ],
  positionFilters: [
    'Job Title 1',
    'Job Title 2',
    'Job Title 3',
    'Job Title 4',
    'Job Title 5',
    'Job Title 6',
  ],
  expertiseFilters: [
    'Expertise 1',
    'Expertise 2',
    'Expertise 3',
    'Expertise 4',
    'Expertise 5',
    'Expertise 6',
  ],
  people: [
    {
      name: 'SARAH RICHARDSON',
      image: '/images/people/people-1.jpg',
      url: '/images/people/people-1.jpg',
      title: 'Job Title 1',
      expertise: 'Expertise 1'
    },
    {
      name: 'SARAH RICHARDSON',
      image: '/images/people/people-1.jpg',
      url: '/images/people/people-1.jpg',
      title: 'Job Title 2',
      expertise: 'Expertise 2'
    },
    {
      name: 'SARAH RICHARDSON',
      image: '/images/people/people-1.jpg',
      url: '/images/people/people-1.jpg',
      title: 'Job Title 3',
      expertise: 'Expertise 3'
    },
    {
      name: 'SARAH RICHARDSON',
      image: '/images/people/people-1.jpg',
      url: '/images/people/people-1.jpg',
      title: 'Job Title 4',
      expertise: 'Expertise 4'
    },
    {
      name: 'SARAH RICHARDSON',
      image: '/images/people/people-1.jpg',
      url: '/images/people/people-1.jpg',
      title: 'Job Title 5',
      expertise: 'Expertise 5'
    },
    {
      name: 'SARAH RICHARDSON',
      image: '/images/people/people-1.jpg',
      url: '/images/people/people-1.jpg',
      title: 'Job Title 6',
      expertise: 'Expertise 6'
    },
  ],
  projects: [
    {
      name: 'Test Project 1',
      image: '/images/projects/thumbnails/auckland-airport-thumbnail.jpg',
      url: '/images/projects/thumbnails/auckland-airport-thumbnail.jpg',
      title: 'Project Title 1',
      type: 'Project Type 1',
      location: 'Location 1'
    },
    {
      name: 'Test Project 2',
      image: '/images/projects/thumbnails/christchurch-justice-thumbnail.jpg',
      url: '/images/projects/thumbnails/christchurch-justice-thumbnail.jpg',
      title: 'Project Title 2',
      type: 'Project Type 2',
      location: 'Location 2'
    },
    {
      name: 'Test Project 3',
      image: '/images/projects/thumbnails/harbour-bridge-thumbnail.jpg',
      url: '/images/projects/thumbnails/harbour-bridge-thumbnail.jpg',
      title: 'Project Title 3',
      type: 'Project Type 3',
      location: 'Location 3'
    },
    {
      name: 'Test Project 4',
      image: '/images/projects/thumbnails/nuffield-thumbnail.jpg',
      url: '/images/projects/thumbnails/nuffield-thumbnail.jpg',
      title: 'Project Title 4',
      type: 'Project Type 4',
      location: 'Location 4'
    },
    {
      name: 'Test Project 5',
      image: '/images/projects/thumbnails/st-patricks-thumbnail.jpg',
      url: '/images/projects/thumbnails/st-patricks-thumbnail.jpg',
      title: 'Project Title 5',
      type: 'Project Type 5',
      location: 'Location 5'
    },
    {
      name: 'Test Project 6',
      image: '/images/projects/thumbnails/te-ana-thumbnail.jpg',
      url: '/images/projects/thumbnails/te-ana-thumbnail.jpg',
      title: 'Project Title 6',
      type: 'Project Type 6',
      location: 'Location 6'
    },
  ],
  projectFilters:{
    featured: [
      'Test Project 1',
      'Test Project 3',
      'Test Project 6',
    ],
    type: [
      'Project Type 1',
      'Project Type 2',
      'Project Type 3',
      'Project Type 4',
      'Project Type 5',
      'Project Type 6',
    ],
    location: [
      'Location 1',
      'Location 2',
      'Location 3',
      'Location 4',
      'Location 5',
      'Location 6',
    ]
  }
}
